<template>
    <div class="onboarding-info-card">
        <b-embed
            class="video-embed"
            type="iframe"
            aspect="16by9"
            :src="getVimeoUrl(729660071)"
            allowfullscreen
        />
        <h1>
            A private portal for every homeowner – with you inside.
        </h1>
        <p>
            <span class="mr-2">💬</span>
            Stay connected
        </p>
        <p>Create homeowner portals to deliver value and win the next transaction.</p>
        <p>
            <span class="mr-2">✉️</span>
            Ongoing touchpoints
        </p>
        <p>
            Automated messaging keeps you front & center until homeowners are ready to transact.
        </p>
        <p>
            <span class="mr-2">💰</span>
            Repeat & referral business
        </p>
        <p>
            Embed your network to help clients solve problems, while getting more referrals.
        </p>
</div>
</template>
<script>

import './OnboardingInfoCard.scss';
import VimeoMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/VimeoMixin";

export default {
    name: 'OnboardingInfoCard',

    mixins: [
        VimeoMixin,
    ],

    data: () => ({
        loading: false,
        activeStep: 'email',
    }),

    computed: {
        title: function () {
            return this.steps[this.activeStep].title;
        },
    },

    methods: {
        clearErrors() {
            this.errors = {
                email: [],
            };
        },
    }
};
</script>
